"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectableFileList = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var classnames_1 = __importDefault(require("classnames"));
var filesize_1 = __importDefault(require("filesize"));
var react_1 = __importStar(require("react"));
require("./FileList.scss");
var SelectableFileList = /** @class */ (function (_super) {
    __extends(SelectableFileList, _super);
    function SelectableFileList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOpenRemoteSource = function (path) {
            _this.props.onOpen(path);
        };
        _this.handleFileSelect = function (file, selected) {
            _this.props.onSelect(file, selected);
        };
        _this.isDirectorySelected = function () {
            return _this.props.selectedFiles.filter(function (f) { return (f.type === 'directory' && _this.props.currentPath.startsWith(f.path)); }).length !== 0;
        };
        _this.isFileSelected = function (file) {
            return _this.props.selectedFiles.filter(function (f) { return (f.filename === file.filename &&
                f.path === file.path &&
                f.type === file.type); }).length !== 0;
        };
        return _this;
    }
    SelectableFileList.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (react_1.default.createElement("div", { className: "file-list" },
            react_1.default.createElement("div", { className: "file-list-items-container selectable" },
                react_1.default.createElement("div", { className: classnames_1.default('file-list-items', props.className) }, props.files.map(function (f) { return react_1.default.createElement(FileListItem, { key: f.filename, currentPath: props.currentPath, file: f, isDirectorySelected: _this.isDirectorySelected(), isFileSelected: _this.isFileSelected(f), onOpen: function () { return _this.handleOpenRemoteSource(f.path); }, onSelect: function (selected) { return _this.handleFileSelect(f, selected); } }); })))));
    };
    return SelectableFileList;
}(react_1.Component));
exports.SelectableFileList = SelectableFileList;
var FileListItem = function (props) {
    var isDirectory = props.file.type === 'directory';
    var isParentDirectory = isDirectory && props.file.filename === '.. Parent Directory';
    var isRootDirectory = isDirectory && (props.currentPath === '' || props.currentPath === '/') && (props.file.path === '' || props.file.path === '/');
    var iconClassName = isDirectory ? 'fa-folder' : 'fa-file';
    var handleOpenDirectory = function () {
        if (isDirectory) {
            props.onOpen();
        }
    };
    var handleSelect = function () {
        props.onSelect(!props.isFileSelected);
    };
    return (react_1.default.createElement("div", { className: classnames_1.default('file-list-item', 'level', 'is-mobile', (isRootDirectory) ? 'hidden' : '') },
        react_1.default.createElement("div", { className: classnames_1.default('level-left') },
            !isParentDirectory &&
                react_1.default.createElement("div", { className: "level-item" },
                    react_1.default.createElement("input", { type: "checkbox", checked: props.isFileSelected || props.isDirectorySelected, disabled: props.isDirectorySelected, onChange: function () { return handleSelect(); } })),
            react_1.default.createElement("div", { className: classnames_1.default('level-item', (isDirectory) ? 'is-directory' : ''), onClick: handleOpenDirectory },
                react_1.default.createElement("i", { className: classnames_1.default('fas', iconClassName) })),
            react_1.default.createElement("div", { className: classnames_1.default('level-item', (isDirectory) ? 'is-directory' : ''), onClick: handleOpenDirectory }, props.file.filename)),
        react_1.default.createElement("div", { className: "level-right" }, !isDirectory &&
            react_1.default.createElement("div", { className: "level-item" },
                react_1.default.createElement("span", { className: "is-size-7" }, filesize_1.default(props.file.size))))));
};
